import axios from "axios";
import $ from "jquery";
import authHeader from "./auth-header";
import AdminService from "./admin.service";
import UserService from "./user.service";
import ErrorService from "./error.service";
import ReportService from "./report.service";
import moment from "moment-timezone";

const API_AI_SERVICE_ADMIN_URL = AdminService.getBaseUrl() + "/api/v1/ai-service";
const API_AI_SERVICE_CHART_URL = AdminService.getBaseUrl() + "/api/v1/chart";

class AIService {
    async getAllAITypes(callback) {
        await axios
            .get(API_AI_SERVICE_ADMIN_URL + "/get-all-ai-types", { headers: await authHeader() })
            .then(response => {
                callback(response.data);
            })
            .catch(error => {
                throw error;
            });
    }

    async getAllActiveAITypes(callback) {
        await axios
            .get(API_AI_SERVICE_ADMIN_URL + "/get-all-active-ai-types", { headers: await authHeader() })
            .then(response => {
                callback(response.data);
            })
            .catch(error => {
                throw error;
            });
    }
  
    async saveAIToolsetToClient(clientCode, aiTypeId, applyToHierarchy, callback, app) {
        const params = new URLSearchParams();
        params.append("clientCode", clientCode);
        params.append("aiTypeId", aiTypeId);
        params.append("applyToHierarchy", applyToHierarchy);
        //params.append("clientSettingTypeName", "ai-type-id");
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_AI_SERVICE_ADMIN_URL + "/save-ai-type-to-client", params, { headers: await authHeader() })
          .then(response => callback(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("AIService.saveAIToolsetToClient", error, "admin", app);
          });
    }

    async saveRecommendationInstructions(clientCode, role, industry, respondentGroup, applyToHierarchy, callback, app) {
        const params = new URLSearchParams();
        params.append("clientCode", clientCode);
        params.append("role", role);
        params.append("industry", industry);
        params.append("respondentGroup", respondentGroup);
        params.append("applyToHierarchy", applyToHierarchy);
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_AI_SERVICE_ADMIN_URL + "/save-recommendation-instructions", params, { headers: await authHeader() })
          .then(response => callback(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("AIService.saveRecommendationInstructions", error, "admin", app);
          });
    }

    async processRecommendations(params, callback) {
        try {
          const response = await axios.post(API_AI_SERVICE_CHART_URL + "/generate-profile-recommendations-by-ai", params, { headers: await authHeader() });
          if (typeof callback == "function") {
            callback(response);
          }
          return response;
        } catch (error) {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("AIService.generateProfileRecommendations", error, "admin", this);
          throw error;
        }
    }
    
    async getAICacheDataList(callback, chartApp) {
        await axios
        .get(API_AI_SERVICE_ADMIN_URL + "/get-ai-cache-data", { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("AIService.getAICacheDataList", error, "admin", chartApp);
        });    
    }

    buildClientOptionList(aiCacheList) {
        const list = [];
        list.push({ name: "Select Client", value: 0 });
        const clientFilteredList = [...new Set(aiCacheList.map(x => x.clientId))]
          .map(clientId => {
            return {
              clientId: clientId,
              clientName: aiCacheList.find(s => s.clientId == clientId).clientName
            };
          });
        if (clientFilteredList.length > 0) {
            clientFilteredList.sort((a, b) =>
                (a.clientName || "").localeCompare(b.clientName || "")
            );
            clientFilteredList.forEach(aiCache => {
                const option = {
                name: aiCache.clientName,
                value: aiCache.clientId,
                };
                list.push(option);
            });
        }
        return list;
    }

    async deleteAIVerbatimsCacheList(aiCacheIdsToDelete,callback,app){
      const params = new URLSearchParams();
      params.append("aiCacheListIds", aiCacheIdsToDelete);
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_AI_SERVICE_ADMIN_URL + "/delete-ai-verbatims-cache-list", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("AIService.deleteAIVerbatimsCacheList", error, "admin", app);
        });
    }

    getAIVerbatimsCacheTableColumnData() {
        return [
        {
            bVisible: true,
            data: "aiCacheId",
            render: function(data, type, full, meta) {
                return '<input type="checkbox" name="aiCacheIdToDelete" value="' + full.aiCacheId + '" >';
            },
            className: "text-left pt-2",
            name: "aiCacheId",
            width: "3rem"
        },
        {
            title: "ID",
            data: "aiCacheId",
            className: "dt-head-left text-left",
            name: "aiCacheId",
            width: "4rem",
            
        },
        { title: "Client", data: "clientName", name: "clientName", class: "text-left", width: "10rem" },
        { title: "Survey", data: "surveyName", name: "surveyName", width: "10rem" },
        { title: "Start Period", data: "startPeriodName", name: "startPeriodName", width: "8rem" },
        { title: "End Period", data: "endPeriodName", name: "endPeriodName", width: "8rem" },
        { title: "# Themes", data: "numberOfThemes", name: "numberOfThemes", className: "dt-head-left text-left", width: "7rem" },
        { title: "# Comments", data: "numberOfComments", name: "numberOfComments", className: "dt-head-left text-left", width: "7rem" },
        { title: "Need", data: "needName", name: "needName", width: "8rem" },
        { title: "AI Type", data: "aiType.displayName", name: "aiType.displayName", width: "10rem" },
        { title: "Failover AI Type", data: "failoverAiType.displayName", name: "failoverAiType.displayName", width: "10rem" },
        { title: "Top Results", data: "results", name: "results", width: "60rem" },
        {
          title: "Date Created",
          data: "dateCreated",
          type: "date",
          name: "dateCreated",
          width: "8rem",
          render: function(data, type, row) {
           return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          },
          className: "dt-head-left text-left"
        },
        {
          title: "Date Completed",
          data: "dateModified",
          type: "date",
          name: "dateModified",
          width: "8rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          },
          className: "dt-head-left text-left"
        }
        ];
    }

    getAICacheResultsByClient(originalList, clientIdToCompare){
        if (typeof originalList != "undefined") {
            return originalList
                .filter(input => Number(input.clientId) == Number(clientIdToCompare))
                .sort((a, b) => (a.clientName || "").localeCompare(b.clientName || ""));
        }
        return {};
    }

    async getAIRecommendationCacheDataList(callback, chartApp) {
        await axios
        .get(API_AI_SERVICE_ADMIN_URL + "/get-ai-recommendation-cache-data", { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("AIService.getAIRecommendationCacheDataList", error, "admin", chartApp);
        });    
    }

    getAIRecommendationsCacheTableColumnData() {
      return [
        {
            bVisible: true,
            data: "aiRecommendationCacheId",
            render: function(data, type, full, meta) {
                return '<input type="checkbox" name="aiRecommendationCacheIdToDelete" value="' + full.aiRecommendationCacheId + '" >';
            },
            className: "text-left pt-2",
            name: "aiRecommendationCacheId",
            width: "3rem"
        },
        {
            title: "ID",
            data: "aiRecommendationCacheId",
            className: "dt-head-left text-left",
            name: "aiRecommendationCacheId",
            width: "4rem",
            
        },
        { title: "Client", data: "clientName", name: "clientName", class: "text-left", width: "10rem" },
        { title: "Survey", data: "surveyName", name: "surveyName", width: "10rem" },
        { title: "# Recommendations", data: "numberOfRecommendations", name: "numberOfRecommendations", className: "dt-head-left text-left", width: "9rem" },
        { title: "Include Value Gaps", data: "includeValueGaps", name: "includeValueGaps", width: "6rem" },
        { title: "Include Expectations", data: "includeExpectations", name: "includeExpectations", width: "6rem" },
        { title: "Include Performance", data: "includePerformance", name: "includePerformance", width: "6rem" },
        { title: "Include WTP", data: "includeWillingnessToPay", name: "includeWillingnessToPay", width: "6rem" },
        { title: "Include Relative Strength", data: "includeRelativeStrength", name: "includeRelativeStrength", width: "8rem" },
        { title: "Include Sentiment Themes", data: "includeSentimentThemes", name: "includeSentimentThemes", width: "9rem" },

        { title: "AI Type", data: "aiType.displayName", name: "aiType.displayName", width: "10rem" },
        { title: "Failover AI Type", data: "failoverAiType.displayName", name: "failoverAiType.displayName", width: "10rem" },
        
        { title: "Themes - Start Period", data: "downloadCommmentsPeriodName", name: "downloadCommmentsPeriodName", width: "6rem" },
        { title: "Themes - End Period", data: "downloadCommmentsEndPeriodName", name: "downloadCommmentsEndPeriodName", width: "6rem" },
        { title: "Themes # Respondents", data: "numberOfRespondents", name: "numberOfRespondents", className: "dt-head-left text-left", width: "7rem" },
        { title: "# Themes", data: "numberOfThemes", name: "numberOfThemes", className: "dt-head-left text-left", width: "7rem" },
        { title: "Themes - Include Partial Responses", data: "includePartialResponses", name: "includePartialResponses", width: "8rem" },
        { title: "Themes - Include Extra Responses", data: "includeExtraResponses", name: "includeExtraResponses", width: "8rem" },
        { title: "Themes AI Type", data: "themesAiType.displayName", name: "themesAiType.displayName", width: "10rem" },
        
        { title: "Results", data: "results", name: "results", width: "60rem" },
        {
          title: "Date Created",
          data: "dateCreated",
          type: "date",
          name: "dateCreated",
          width: "8rem",
          render: function(data, type, row) {
           return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          },
          className: "dt-head-left text-left"
        },
        {
          title: "Date Completed",
          data: "dateModified",
          type: "date",
          name: "dateModified",
          width: "8rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          },
          className: "dt-head-left text-left"
        }
      ];
    }

    async deleteAIRecommendationsCacheList(aiRecommendationCacheIdsToDelete,callback,app){
      const params = new URLSearchParams();
      params.append("aiCacheListIds", aiRecommendationCacheIdsToDelete);
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_AI_SERVICE_ADMIN_URL + "/delete-ai-recommendation-cache-list", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("AIService.deleteAIRecommendationsCacheList", error, "admin", app);
        });
    }

    async getAIAuditLog(callback, chartApp) {
        await axios
        .get(API_AI_SERVICE_ADMIN_URL + "/get-ai-audit-log", { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("AIService.getAIAuditLog", error, "admin", chartApp);
        });    
    }

    getAIAuditTableColumnData() {
      return [
        // {
        //     bVisible: true,
        //     data: "aiAuditId",
        //     render: function(data, type, full, meta) {
        //         return '<input type="checkbox" name="aiRecommendationCacheIdToDelete" value="' + full.aiAuditId + '" >';
        //     },
        //     className: "text-left pt-2",
        //     name: "aiAuditId",
        //     width: "3rem"
        // },
        {
            title: "ID",
            data: "aiAuditId",
            className: "dt-head-left text-left",
            name: "aiAuditId",
            width: "4rem",
            
        },
        { title: "Client", data: "clientName", name: "clientName", class: "text-left", width: "10rem" },
        { title: "Survey", data: "surveyName", name: "surveyName", width: "10rem" },

        { title: "AI Type", data: "aiType.displayName", name: "aiType.displayName", width: "7rem" },
        { title: "Module", data: "aiTypeConfiguration.name", name: "aiTypeConfiguration.name", width: "7rem" },

        { title: "Status Code", data: "statusCode", name: "statusCode", className: "dt-head-left text-left", width: "9rem",
          createdCell: function(td, cellData, rowData, row, col) {
            if (cellData == "503") {
              $(td).css("background-color", "red");
              $(td).css("color", "white");
            } else if (cellData == "200") {
              $(td).css("background-color", "green");
              $(td).css("color", "white");
            } else if (cellData == "429") {
              $(td).css("background-color", "orange");
              $(td).css("color", "white");
            } else if (cellData == "400") {
              $(td).css("background-color", "yellow");
              $(td).css("color", "black");
            }
            $(td).addClass("text-center");
          }
        },
        { title: "Prompt Tokens", data: "promptTokens", name: "promptTokens", className: "dt-head-left text-left", width: "7rem" },
        { title: "Completion Tokens", data: "completionTokens", name: "completionTokens", className: "dt-head-left text-left", width: "9rem" },
        { title: "Total Tokens", data: "totalTokens", name: "totalTokens", className: "dt-head-left text-left", width: "7rem" },
        { title: "Cost USD", data: "costUsd", name: "costUsd", className: "dt-head-left text-left", width: "7rem" },
        { title: "Duration (ms)", data: "duration", name: "duration", className: "dt-head-left text-left", width: "7rem" },

        { title: "Status", data: "status", name: "status", width: "16rem" },
        { title: "Error Type", data: "errorType", name: "errorType", className: "dt-head-left text-left", width: "7rem" },
        { title: "Error Message", data: "errorMessage", name: "errorMessage", width: "16rem" },

        {
          title: "Date Created",
          data: "dateCreated",
          type: "date",
          name: "dateCreated",
          width: "8rem",
          render: function(data, type, row) {
           return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          },
          className: "dt-head-left text-left"
        },
        {
          title: "Date Completed",
          data: "dateModified",
          type: "date",
          name: "dateModified",
          width: "8rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          },
          className: "dt-head-left text-left"
        }
      ];
    }

    buildAISectionOptionList(sectionList, sectorId = 0) {
      const list = [];
      list.push({
        name: "Select Module",
        value: ""
      });
      if (sectorId != 0){
        sectionList = sectionList.filter(s => Number(s.sectorId) == Number(sectorId));
      }
      const moatFilteredList = [...new Set(sectionList.map(x => x.aiTypeConfiguration.name))]
        .map(name => {
          return {
            name: name
          };
        });
  
      if (moatFilteredList.length > 0) {
        moatFilteredList.sort(ReportService.compareValues("name", "asc"));
  
        moatFilteredList.forEach(initiative => {
          const option = {
            name: initiative.name,
            value: initiative.name  // Bind value to name string
          };
          list.push(option);
        });
      }
  
      return list;
    }

     getAIAuditLogsBySectorName(originalList, sectorNameToCompare){
      if (typeof originalList != "undefined") {
          return originalList.filter(input => String(input.aiTypeConfiguration.name) == String(sectorNameToCompare));
      } 
      return {};
    }

    async saveAICacheToggleValue(value, aiModuleName, callback, app) {
      const params = new URLSearchParams();
      params.append("cacheValue", value);
      params.append("aiModuleName", aiModuleName);
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_AI_SERVICE_ADMIN_URL + "/save-ai-cache-toggle-value", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("AIService.saveAICacheToggleValue", error, "admin", app);
        });
    }

    async getAICacheToggleValue(aiModuleName, callback, app) {
      const params = new URLSearchParams();
      params.append("aiModuleName", aiModuleName);
      params.append("userId", UserService.getUserId());

      await axios
        .post(API_AI_SERVICE_ADMIN_URL + "/get-ai-cache-toggle-value", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("AIService.getAICacheToggleValue", error, "admin", app);
        });
    }

    buildAITypeOptionList(sectionList, sectorId = 0) {
      const list = [];
      list.push({
        name: "Select AI Model",
        value: ""
      });
      if (sectorId != 0){
        sectionList = sectionList.filter(s => Number(s.sectorId) == Number(sectorId));
      }
      const moatFilteredList = [...new Set(sectionList.map(x => x.aiType.displayName))]
        .map(name => {
          return {
            name: name
          };
        });
  
      if (moatFilteredList.length > 0) {
        moatFilteredList.sort(ReportService.compareValues("name", "asc"));
  
        moatFilteredList.forEach(initiative => {
          const option = {
            name: initiative.name,
            value: initiative.name  // Bind value to name string
          };
          list.push(option);
        });
      }
  
      return list;
    }

    getAIAuditLogsByAiTypeName(originalList, sectorNameToCompare){
      if (typeof originalList != "undefined") {
          return originalList.filter(input => String(input.aiType.displayName) == String(sectorNameToCompare));
      } 
      return {};
    }
}
export default new AIService();
